import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { onUpdatePassword } from "../../redux/homeAction";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useParams();
  const [searchParams] = useState(new URLSearchParams(window.location.search));
  const email = searchParams.get('email');
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!passwords.newPassword || !passwords.confirmPassword) {
      toast.error("Please fill all fields");
      return;
    }
    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    if (passwords.newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    dispatch(onUpdatePassword({ 
      token, 
      email,
      newPassword: passwords.newPassword 
    }, navigate));
  };

  return (
    <section id="login">
      <div className="login_content">
        <div className="row gy-5">
          <div className="col-lg-6 d-flex justify-content-center align-items-center">
            <div className="login-container text-center">
              <h1>
                Reset Your <span className="color_yellow">Password</span>
              </h1>
              <form onSubmit={handleSubmit}>
                <div className="row gy-3">
                  <div className="col-md-12">
                    <div className="form-group floating position-relative">
                      <input
                        type="password"
                        className="form-control floating input"
                        name="newPassword"
                        value={passwords.newPassword}
                        onChange={handleChange}
                        required
                      />
                      <label>New Password</label>
                      <div className="input_icon">
                        <i className="fa-solid fa-lock" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group floating position-relative">
                      <input
                        type="password"
                        className="form-control floating input"
                        name="confirmPassword"
                        value={passwords.confirmPassword}
                        onChange={handleChange}
                        required
                      />
                      <label>Confirm Password</label>
                      <div className="input_icon">
                        <i className="fa-solid fa-lock" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <input type="submit" value="Reset Password" className="input submit_input" />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <div className="login_right">
              <img src="/images/login_right.png" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword; 